export default "__VITE_ASSET__jtcjgXgp__"